// eslint-disable-next-line no-unused-vars
import { Row, Col, Image, Typography, Spin } from 'antd'
import { useQuery } from 'react-query'
import ContractTripsResults from './ContractTrips/ContractTripsResults'
import PackageUsage from './PackageUsage/PackageUsage'
import KilometresUsage from './KilometresUsage/kilometresUsage'
import ContractInfo from './ContractInfo/ContractInfo'
import anytimeHomepage from '../../assets/btm logo.png'
import  EndPoints from "../../shared/endPoints/EndPoints.json"
import { useAuthContext } from '../../shared/context/auth-context'
import useHttpClient from '../../shared/sendRequest/useHttpClient'

import './homePage.css'

function useContractInfo() {
    const { sendRequest } = useHttpClient()
    const { ContractId } = useAuthContext()
    return useQuery('getContractInfo', async () => sendRequest({
        endpoint: `${EndPoints.BASEURL + EndPoints.CONTRACT.GETCONTRACTBYID}/${ContractId}`,
        method: 'GET',
    })
    )
}

function useContractNotificationMessage() {
    const { sendRequest } = useHttpClient()
    return useQuery('getNotificationMessage', async () => sendRequest({
        endpoint: `${EndPoints.BASEURL + EndPoints.NOTIFICATION.NOTIFICATION}`,
        method: 'GET',
    })
    )
}

export default function HomePage() {
    const { Text } = Typography
    const { status, data } = useContractInfo()
    const { status:notificationStatus, data :notificationData } = useContractNotificationMessage()

    if (status === 'loading' || notificationStatus==='loading' ) {
        return (
            <Row justify="center">
                <Col>
                    <Spin size='large' />
                </Col>
            </Row>

        )
    }

    return (
        <>
            <Row justify='center' >
                <Col xs={{span:6 ,pull:10}} md={{span: 6 , offset:20}} ><Image preview={false} width={360} src={anytimeHomepage} style={{margin:'20px'}}/></Col>
            </Row>
             <Row >
                <Col className='message'>
                    <Text style={{ fontWeight: 'bold' }}>
                        {notificationData?.description}
                    </Text>
                </Col>
            </Row> 
            {
                data ?
                    <Row justify="center" >
                        <Col xs={24} sm={24} md={24} lg={10}><ContractInfo /></Col>
                        <Col xs={24} sm={24} md={24} lg={10}><KilometresUsage /></Col>
                        <Col xs={24} sm={24} md={24} lg={10}><ContractTripsResults /></Col>
                        <Col xs={24} sm={24} md={24} lg={10}><PackageUsage /></Col>
                    </Row> :
                    <Row justify="center">
                        <Col>Τα δεδομένα δεν είναι διαθέσιμα αυτή τη στιγμή</Col>
                    </Row>
            }
        </>
    )
}
